import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Scrollbars from "react-custom-scrollbars";
import { AttributesType, IProject, Steps } from "../../reducers/project";
import AttributesExpansion from "../../components/Attributes/AttributesExpansion";
import content from "../../content";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentProject } from "../../reducers/project/selectors";
import { useFetch } from "../../hooks/useFetch";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { Button, Price } from "../Page/Creator";
import useDesktop from "../../components/Responsive/useDesktop";
import Step1 from "./Attrib/Step1";
import Step2 from "./Attrib/Step2";
import Step3 from "./Attrib/Step3";
import Step4 from "./Attrib/Step4";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 250, 1);
  display: flex;
  @media (max-width: 1023px) {
    flex-direction: column;
    padding: 0 18px 24px;
  }
`;

const headerColors = ["#E7A937", "#F3A821", "#E5981C", "#CB8013"];

function Attributes({ onClick, addProject }: IAttributes) {
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollMax, setScrollMax] = useState(0);
    const project = useSelector(getCurrentProject);
    const [responseNew, requestNew] = useFetch<IProject>("/project/");
    const [responseUpdate, requestUpdate] = useFetch<IProject>(
        "/project/",
        {} as any,
        {
            method: "PUT",
        }
    );

    const desktop = useDesktop();

    const dispatch = useDispatch();

    useEffect(() => {
        if (project.components.length !== 0 && project.components.every(Boolean)) {
            if (project.id) {
                requestUpdate(project, project.id).then((data) => {
                    dispatch({
                        type: ProjectActions.UpdateHistory,
                        project: data,
                    });
                });
            } else {
                requestNew(project).then((data) => {
                    dispatch({
                        type: ProjectActions.UpdateHistory,
                        project: data,
                    });
                });
            }
        }
    }, [project.components]);

    const [expanded, setExpanded] = useState<undefined | string>(
        Object.values(AttributesType)[0]
    );

    const toggleExpand = (name: string) => {
        setExpanded(name);
    };

    const expandNext = (name: string) => () => {
        const attr = Object.values(AttributesType);
        setExpanded(attr[attr.indexOf(name as AttributesType) + 1]);
    };

    return (
        <Wrapper>
            <Step1
                scrollTop={scrollTop}
                scrollMax={scrollMax}
                setScrollTop={setScrollTop}
                setScrollMax={setScrollMax}
                bgcolor={headerColors[Number(0)]}
                name={`${content.getValue("Krok")} ${Number(0) + 1}`}
                step={0}
            />
            <Step2
                scrollTop={scrollTop}
                scrollMax={scrollMax}
                setScrollTop={setScrollTop}
                setScrollMax={setScrollMax}
                bgcolor={headerColors[Number(1)]}
                name={`${content.getValue("Krok")} ${Number(1) + 1}`}
                step={1}
            />
            <Step3
                scrollTop={scrollTop}
                scrollMax={scrollMax}
                setScrollTop={setScrollTop}
                setScrollMax={setScrollMax}
                bgcolor={headerColors[Number(2)]}
                name={`${content.getValue("Krok")} ${Number(2) + 1}`}
                step={2}
            />
            <Step4
                scrollTop={scrollTop}
                scrollMax={scrollMax}
                setScrollTop={setScrollTop}
                setScrollMax={setScrollMax}
                bgcolor={headerColors[Number(2)]}
                name={`${content.getValue("Krok")} ${Number(2) + 1}`}
                step={3}
            />
            {/*{Object.values(Steps)*/}
            {/*    .filter((k) => !isNaN(k as any))*/}
            {/*    .map((k, i, arr) => (*/}
            {/*        <AttributesExpansion*/}
            {/*            scrollTop={scrollTop}*/}
            {/*            scrollMax={scrollMax}*/}
            {/*            setScrollTop={setScrollTop}*/}
            {/*            setScrollMax={setScrollMax}*/}
            {/*            bgcolor={headerColors[Number(k)]}*/}
            {/*            name={`${content.getValue("Krok")} ${Number(k) + 1}`}*/}
            {/*            step={k}*/}
            {/*        />*/}
            {/*    ))}*/}
            {!desktop && (
                <div>
                    <Price />
                    <Button onClick={addProject} />
                </div>
            )}
        </Wrapper>
    );
}

export interface IAttributes {
    onClick: any;
    addProject: any;
}

export default Attributes;
